import script from "./PublicStatisticsYearly.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicStatisticsYearly.vue?vue&type=script&setup=true&lang=js"

import "./PublicStatisticsYearly.vue?vue&type=style&index=0&id=7e293ceb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e293ceb"]])

export default __exports__